const NOTIFICATION_TONES = [1046.5, 1318.5];
const NOTIFICATION_NOTE_DURATION = 0.15;
const NOTIFICATION_VOLUME = 1.0;

let audioContext = null;

const getContext = () => {
  if (!audioContext || audioContext.state === 'closed') {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioContext;
};

// A context created outside a user gesture stays suspended (silent, no error).
export const unlockAudioContext = () => {
  try {
    const ctx = getContext();
    if (ctx.state !== 'running') {
      const p = ctx.resume();
      if (p && p.then) p.catch(() => {});
    }
  } catch (e) {}
};

const playChime = ctx => {
  NOTIFICATION_TONES.forEach((freq, i) => {
    const startAt = ctx.currentTime + i * NOTIFICATION_NOTE_DURATION;
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();

    oscillator.connect(gain);
    gain.connect(ctx.destination);

    oscillator.type = 'sine';
    oscillator.frequency.value = freq;
    gain.gain.setValueAtTime(NOTIFICATION_VOLUME, startAt);
    gain.gain.exponentialRampToValueAtTime(0.01, startAt + NOTIFICATION_NOTE_DURATION);

    oscillator.start(startAt);
    oscillator.stop(startAt + NOTIFICATION_NOTE_DURATION);
  });
};

export const playNotificationSound = () => {
  try {
    const ctx = getContext();
    if (ctx.state === 'running') {
      playChime(ctx);
      return;
    }
    const p = ctx.resume();
    if (p && p.then) p.then(() => playChime(ctx)).catch(() => {});
    else playChime(ctx); // webkit: resume() returns undefined
  } catch (e) {}
};
